module.exports = __webpack_public_path__ + "img/Bannerwide_HailapartitaIva_Mobile.98cab8a6.png";